import { useState, useEffect } from 'react';
import h from '../helpers/common';

const useLanguage = () => {
    const [language, setLanguage] = useState(h.getLang());

    useEffect(() => {
        const handleLanguageChange = () => {
            setLanguage(h.getLang());
        };

        document.addEventListener('languageSwitched', handleLanguageChange);

        return () => {
            document.removeEventListener('languageSwitched', handleLanguageChange);
        };
    }, []);

    return language;
};

export default useLanguage;
